import { Dialog, DialogType } from '../../../../src/feature/narrator/narrator.model';
import { BASE_CAPACITY } from '../../inventory/capacity';
import { currentWeight, getItemCount, hasItem } from '../../inventory/helpers';

const BACKPACK_PRICE = 24; // 2 sous

export const dialog: Dialog[] = [
  {
    id: 'start',
    type: DialogType.description,
    text: 'The merchant sits at a table outside a low house. Cloth, iron nails, and dried herbs lie under his hand. He weighs a coin in his palm and watches you come.',
    options: [
      { text: 'Sell or buy wares.', nextDialogId: 'wares' },
      { text: 'Talk with him.', nextDialogId: 'talk' },
    ],
  },
  {
    id: 'wares',
    type: DialogType.dialog,
    openMerchant: true,
    text: 'Lay your goods on the table, friend. I pay fair coin for fish. Coin is honest. The rest is talk.',
    options: [{ text: 'Step back from the table.', nextDialogId: 'start' }],
  },
  {
    id: 'talk',
    type: DialogType.dialog,
    text: 'Cloth, nails, dried herbs for a sick belly. A little of this, a little of that. I go where the roads take me.',
    options: [
      {
        text: 'Anything to help me carry more?',
        nextDialogId: () => {
          if (hasItem('backpack')) return currentWeight() <= BASE_CAPACITY ? 'pack_sell' : 'pack_too_full';
          return getItemCount('coins') >= BACKPACK_PRICE ? 'pack_offer' : 'pack_poor';
        },
      },
      { text: 'Heard any news on the road?', nextDialogId: 'news' },
    ],
  },
  {
    id: 'pack_offer',
    type: DialogType.dialog,
    text: 'A stout backpack, good leather. Two sous, and you will carry far more than your two arms allow.',
    options: [
      { text: 'Buy it.', nextDialogId: 'pack_bought' },
      { text: 'Maybe later.', nextDialogId: 'talk' },
    ],
  },
  {
    id: 'pack_bought',
    type: DialogType.dialog,
    text: 'Wear it well. Your shoulders will complain, but your purse will thank you for what it carries.',
    effects: [
      { type: 'consume', item: 'coins', quantity: BACKPACK_PRICE },
      { type: 'grant', item: 'backpack', quantity: 1 },
    ],
    options: [{ text: 'My thanks.', nextDialogId: 'talk' }],
  },
  {
    id: 'pack_poor',
    type: DialogType.dialog,
    text: 'A stout backpack, two sous. Come back when your purse is heavier, friend.',
    options: [{ text: 'I will.', nextDialogId: 'talk' }],
  },
  {
    id: 'pack_sell',
    type: DialogType.dialog,
    text: 'Done with the backpack? I will take it back for the two sous you paid. A fair trade.',
    options: [
      { text: 'Sell it back.', nextDialogId: 'pack_sold' },
      { text: 'Keep it.', nextDialogId: 'talk' },
    ],
  },
  {
    id: 'pack_sold',
    type: DialogType.dialog,
    text: 'There. Lighter on your back, heavier in your purse. Come find me when the roads ask more of you.',
    effects: [
      { type: 'consume', item: 'backpack', quantity: 1 },
      { type: 'grant', item: 'coins', quantity: BACKPACK_PRICE },
    ],
    options: [{ text: 'My thanks.', nextDialogId: 'talk' }],
  },
  {
    id: 'pack_too_full',
    type: DialogType.dialog,
    text: 'Sell it back? Empty it first, friend. You cannot carry that load on your two arms alone.',
    options: [{ text: 'Right.', nextDialogId: 'talk' }],
  },
  {
    id: 'news',
    type: DialogType.dialog,
    text: 'Fewer people on the roads this year. There is sickness in the south, they say. I do not go that way now.',
    options: [
      { text: 'Is it coming here?', nextDialogId: 'news_more' },
      { text: 'Let me trade, then.', nextDialogId: 'wares' },
    ],
  },
  {
    id: 'news_more',
    type: DialogType.dialog,
    text: 'Not here, not yet. The county watches its bridges and turns the sick away. I keep to the north roads and sleep with one eye open.',
    options: [
      { text: 'Wise. Let me trade.', nextDialogId: 'wares' },
      { text: 'Safe travels.', nextDialogId: 'start' },
    ],
  },
];
